import * as React from "react";
import { forwardRef } from "react";
const SvgIconToolLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11 21.5V15.5H13V17.5H21V19.5H13V21.5H11ZM3 19.5V17.5H9V19.5H3ZM7 15.5V13.5H3V11.5H7V9.5H9V15.5H7ZM11 13.5V11.5H21V13.5H11ZM15 9.5V3.5H17V5.5H21V7.5H17V9.5H15ZM3 7.5V5.5H13V7.5H3Z", fill: "#A4A4A4" }));
const ForwardRef = forwardRef(SvgIconToolLeft);
export default ForwardRef;
